import { render, staticRenderFns } from "./cardManage.vue?vue&type=template&id=28a04c0d&"
import script from "./cardManage.vue?vue&type=script&lang=js&"
export * from "./cardManage.vue?vue&type=script&lang=js&"
import style0 from "./cardManage.vue?vue&type=style&index=0&id=28a04c0d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports